import React from 'react';

const ChefLocation = props => {
  const { serviceDistricts = [], availableServiceDistricts = [] } = props;
  const list = prepList(serviceDistricts, availableServiceDistricts);

  return (
    <div className="cms__section">
      <div className="cms__bar cms__section-head">
        <div className="cms__bar-left">
          <h3 className="h3">Preferred Location</h3>
        </div>
        <div className="cms__bar-right">
          <div
            className="a--blue"
            onClick={props.openModal}
            data-test="edit-preferred-location"
          >
            Edit
          </div>
        </div>
      </div>
      <div className="cms__section-body chef-location-list">
        <LocationGroup list={list} />
      </div>
    </div>
  );
};
export default ChefLocation;

const LocationGroup = ({ list }) => {
  return list.map((group, i) => (
    <div key={i} className="chef-location-list__group">
      <p className="p p--bold chef-location-list__p">{group.name}</p>
      {group.prettyDistricts.map((name, j) => (
        <p key={j} className="p">
          {name}
        </p>
      ))}
    </div>
  ));
};

const prepList = (serviceDistricts, availableServiceDistricts) => {
  const ids = serviceDistricts.map(d => d.id);
  return availableServiceDistricts
    .filter(d => d.service_district_subsections.some(el => ids.includes(el.id)))
    .map(d => {
      const subIDs = d.service_district_subsections.map(s => s.id);
      d.prettyDistricts = serviceDistricts
        .filter(sd => subIDs.includes(sd.id))
        .map(sd => sd.name);
      return d;
    });
};



// WEBPACK FOOTER //
// ./src/components/chef/ChefLocation.js